import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed3efc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-inline",
  viewBox: "0 0 61 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M45.0913 38.5719L48.666 38.5714V31.4694L42.666 24.8571H36.666V38.5714M45.0913 38.5719C44.7384 37.5729 43.7858 36.8571 42.666 36.8571M45.0913 38.5719C45.186 38.8399 45.2374 39.1282 45.2374 39.4286M42.666 36.8571C41.5462 36.8571 40.5936 37.5729 40.2407 38.5719M42.666 36.8571C44.0862 36.8571 45.2374 38.0084 45.2374 39.4286M42.666 36.8571C41.2459 36.8571 40.0946 38.0084 40.0946 39.4286M40.2407 38.5719L36.666 38.5714M40.2407 38.5719C40.1461 38.8399 40.0946 39.1282 40.0946 39.4286M36.666 38.5714V18H12.666M36.666 38.5714L24.5199 38.5719M24.5199 38.5719C24.167 37.5729 23.2144 36.8571 22.0946 36.8571M24.5199 38.5719C24.6145 38.8399 24.666 39.1282 24.666 39.4286M22.0946 36.8571C20.9748 36.8571 20.0222 37.5729 19.6693 38.5719M22.0946 36.8571C23.5147 36.8571 24.666 38.0084 24.666 39.4286M22.0946 36.8571C20.6744 36.8571 19.5232 38.0084 19.5232 39.4286M19.6693 38.5719L17.8089 38.5714M19.6693 38.5719C19.5747 38.8399 19.5232 39.1282 19.5232 39.4286M45.2374 39.4286C45.2374 40.8487 44.0862 42 42.666 42C41.2459 42 40.0946 40.8487 40.0946 39.4286M24.666 39.4286C24.666 40.8487 23.5147 42 22.0946 42C20.6744 42 19.5232 40.8487 19.5232 39.4286",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17.037 29.5283L19.1562 31.1343C19.5864 31.4603 20.1977 31.3861 20.5374 30.9666L26.4326 23.686",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.4248 31.9213L23.8093 32.2322C24.6679 32.9262 25.9263 32.7933 26.621 31.9354L32.4968 24.6788C32.8444 24.2495 32.7782 23.6199 32.349 23.2723C31.9198 22.9248 31.2901 22.991 30.9425 23.4202L25.0666 30.6768L24.6834 30.367L23.4248 31.9213Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}